<app-sidebar [user]="user?.name"></app-sidebar>
<app-header [name]="user?.name" [surname]="user?.surname" [email]="user?.email" [phone]="user?.phoneNumber"
            [id]="user?.id"></app-header>
<div class="page-wrapper admin"  [ngClass]="{'admin-users': isUserPage || isReviewsPage}">
      <router-outlet></router-outlet>
</div>
